const markSecondaryReady = (image) => {
  const layer = image.closest('[data-daedae-secondary-media]');
  if (!layer) return;
  if (image.complete && image.naturalWidth > 0) {
    layer.classList.add('is-loaded');
    layer.closest('product-card')?.classList.add('is-secondary-loaded');
  }
};

const prepareSecondaryImages = (root = document) => {
  root.querySelectorAll('[data-daedae-secondary-media] img').forEach((image) => {
    if (image.complete) {
      markSecondaryReady(image);
      return;
    }
    image.addEventListener('load', () => markSecondaryReady(image), { once: true });
  });
};

const supportsFineHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

const clearStickyHoverState = (root = document) => {
  if (supportsFineHover()) return;

  root.querySelectorAll('.daedae-catalog-surface product-card').forEach((card) => {
    card.classList.remove('is-touch-preview');
    card.blur?.();
    card.querySelectorAll(':focus').forEach((el) => el.blur?.());
  });
};

if (!window.__daedaeCollectionTouchGuardBound) {
  window.__daedaeCollectionTouchGuardBound = true;

  document.addEventListener(
    'touchend',
    () => {
      clearStickyHoverState();
    },
    { passive: true }
  );

  window.addEventListener('pagehide', () => clearStickyHoverState(), { passive: true });
}

prepareSecondaryImages();
clearStickyHoverState();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) prepareSecondaryImages(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
